// extracted by css-extract-rspack-plugin
module.exports =  {"template-39":"Template39-LD6R__template-39"};